"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosCannabisPatientAllotmentSchema = void 0;
const zod_1 = require("zod");
const timestamps_schema_1 = require("../../common/timestamps.schema");
const id_schema_1 = require("../../common/id.schema");
exports.APosCannabisPatientAllotmentSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    allotmentId: id_schema_1.EntityIdSchema,
    customerId: id_schema_1.EntityIdSchema,
    patientId: zod_1.z.string().min(1).max(50),
    state: zod_1.z.string().length(2),
    period: zod_1.z.enum(['daily', 'weekly', 'monthly', 'rolling_30']),
    maxQuantityGrams: zod_1.z.number().positive(),
    usedQuantityGrams: zod_1.z.number().nonnegative().default(0),
    remainingQuantityGrams: zod_1.z.number().nonnegative(),
    periodStart: zod_1.z.number(),
    periodEnd: zod_1.z.number(),
    lastPurchaseDate: zod_1.z.number().optional(),
    isActive: zod_1.z.boolean().default(true),
}).merge(timestamps_schema_1.TimestampsSchema);
//# sourceMappingURL=cannabis-patient-allotment.schema.js.map